import moment from 'moment';
import memoize from 'memoizee';

export const CURRENT_YEAR = new Date().getFullYear();

export const commDateFormat = (() => {
    let lastLocale = '';

    // 로케일별 포맷 변환 함수
    const transformFormat = (format, locale) => {
        // MMM Do YYYY 형식일 때 로케일별로 년도 표시 추가
        if (format === 'MMM Do YYYY') {
            if (locale === 'ko') {
                return 'MMM Do YYYY[년]';
            } else if (locale === 'ja') {
                return 'MMM Do YYYY[年]';
            }
        }
        return format || 'YYYY-MM-DD';
    };

    return (date, format, locale) => {
        if (locale && typeof locale === 'string' && lastLocale !== locale) {
            lastLocale = locale;
            setMomentLocale(locale);
        }

        const transformedFormat = transformFormat(format, locale);
        return moment(date).format(transformedFormat);
    };
})();

export function makeDurationFormat(duration, format) {
    return moment.duration(duration).format(format, { trim: false });
}

export function makeDurationMilliseconds(duration) {
    return moment.duration(duration).asMilliseconds();
}

export const pastNDays = (n = 0, date) =>
    moment(date).subtract(n, 'days').toDate();

export const setMomentLocale = (locale) => {
    moment.locale(locale);
};

export const daysDiff = ({ from, to }) => moment(to).diff(moment(from), 'days');

export const endOfDay = (d) => moment(d).endOf('day').toDate();

export const isPast = (d) => moment(d).isBefore(new Date());

export const getDefaultDate = () => {
    const formatter = R.curryN(3, commDateFormat)(R.__, 'YYYY-MM-DD');
    return [pastNDays(30), new Date()].map(formatter);
};

export const getStartOrEndDateOfDateUnit = ({
    date,
    dateUnit,
    startDate = true,
}) => {
    if (dateUnit === 'week') {
        return startDate
            ? moment(date).startOf('isoWeek').format('YYYY-MM-DD')
            : moment(date).endOf('isoWeek').format('YYYY-MM-DD');
    } else if (dateUnit === 'month') {
        return startDate
            ? moment(date).startOf('month').format('YYYY-MM-DD')
            : moment(date).endOf('month').format('YYYY-MM-DD');
    } else {
        return date;
    }
};

export const getDateGroupUnit = ({ from, to }) => {
    if (!from || !to) return 'day';

    let duration = moment(to).diff(from, 'days');

    let dateGroup;

    if (duration < 90) {
        dateGroup = 'day';
    } else if (duration < 365) {
        dateGroup = 'week';
    } else {
        dateGroup = 'month';
    }
    return dateGroup;
};

export const getDateListBetweenStartAndEnd = memoize(
    ({ from, to, dateUnit, hasStartAndEnd = true }) => {
        if (!from || !to) return;

        if (!dateUnit) {
            dateUnit = getDateGroupUnit({ from, to });
        }

        const dateUnitMap = {
            day: 'days',
            week: 'weeks',
            month: 'months',
        };

        const _dateUnit = dateUnitMap[dateUnit];

        if (!_dateUnit) {
            return;
        }

        let date = [];
        const mFrom = moment(from);
        const mTo = moment(to);

        while (mFrom <= mTo) {
            date.push(mFrom.format('YYYY-MM-DD'));
            mFrom.add(1, _dateUnit);
        }

        if (!hasStartAndEnd) {
            date.shift();
            date.pop();
        }

        return date;
    },
    {
        normalizer: JSON.stringify,
        maxAge: 2 * 60 * 1000, // 2 minutes
        max: 1000,
    }
);

export const isTodayIncluded = (date) => {
    return (
        moment(date).format('YYYY-MM-DD') ===
        moment(new Date()).format('YYYY-MM-DD')
    );
};

export const parseSecToFullFormat = (seconds) => {
    return moment
        .duration(seconds, 'seconds')
        .format('HH:mm:ss', { trim: false });
};
